var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTemple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 50,
    viewBox: "0 0 43 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2679_756)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.6583 21.5303C42.6583 27.9364 41.0624 32.2448 34.7946 38.002C34.6773 38.1115 21.4844 49.3372 21.4844 49.3372C21.4844 49.3372 8.2363 37.9212 8.11895 37.8117C3.32597 33.597 0.318359 27.9364 0.318359 21.5303C0.318359 9.83661 9.79849 0.364258 21.4844 0.364258C33.1781 0.364258 42.6583 9.83661 42.6583 21.5303Z",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5642 38.2334C30.8763 38.2334 38.4253 30.6844 38.4253 21.3723C38.4253 12.0602 30.8763 4.51123 21.5642 4.51123C12.2521 4.51123 4.70312 12.0602 4.70312 21.3723C4.70312 30.6844 12.2521 38.2334 21.5642 38.2334Z",
    fill: "#A2DB67",
    stroke: "#55990E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5907 19.3594L28.1217 30.6709H13.9375L20.4685 19.3594V11.0386L28.9801 14.1582L21.5907 17.2778V19.3594Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2679_756"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.3399,
    height: 48.9729,
    fill: "white",
    transform: "translate(0.318359 0.364258)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemple);
export default __webpack_public_path__ + "static/media/temple.bd28f3cf0de7088b4ad233746a8d0b05.svg";
export { ForwardRef as ReactComponent };